module.exports = __webpack_public_path__ + "components/weather-icon/static/nightmodsnow@3-209633a299e60dc1ff4ebf67c02e440b.png";